export type MessageModalState = {
    icon?: string;
    title?: string;
    message?: string;
};

export const MessageModalInitialState: MessageModalState = {};